import React, { useState, useRef, useEffect } from 'react';
import Transition from '../../utils/Transition';

function FilterButton({
  setSearch,
  search,
  setClick,
  click,
  lastLogin,
  setLastLogin,
  setUserType,
  userType,
  setPlanType,
  setStatusType,
  statusType,
  planType,
  setEnrollmentDate,
  enrollmentDate,
  setOrganization,
  organization,
  setPlan,
  plan,
}) {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const trigger = useRef(null);
  const dropdown = useRef(null);

  // Close on click outside
  useEffect(() => {
    const clickHandler = ({ target }) => {
      if (!dropdownOpen || dropdown.current.contains(target) || trigger.current.contains(target)) return;
      setDropdownOpen(false);
    };
    document.addEventListener('click', clickHandler);
    return () => document.removeEventListener('click', clickHandler);
  });

  // Close if the ESC key is pressed
  useEffect(() => {
    const keyHandler = ({ keyCode }) => {
      if (!dropdownOpen || keyCode !== 27) return;
      setDropdownOpen(false);
    };
    document.addEventListener('keydown', keyHandler);
    return () => document.removeEventListener('keydown', keyHandler);
  });

  const handleFilterChange = (event) => {
    setSearch(event.target.value); // Update the filter query as the user types
  };

  const handleUserTypeChange = (event) => {
    setUserType(event.target.value); // Update the user type filter
  };
  const handlePlanChange = (event) => {
    setPlanType(event.target.value); // Update the user type filter
  };
  const handleStatusChange = (event) => {
    setStatusType(event.target.value); 
  };
  const clearFilter = () => {
    setSearch(''); // Clear the filter query
    setClick(!click);
    setLastLogin(false);
    setUserType(''); // Clear user type filter
    setPlanType('')
    setStatusType('')
  };

  // Ensure only one sort option is checked
  const handleSortChange = (sortType) => {
    if (sortType === 'lastLogin' && lastLogin) {
      setLastLogin(false); // Deselect if already selected
    } else {
      setLastLogin(sortType === 'lastLogin');
    }

    if (sortType === 'enrollmentDate' && enrollmentDate) {
      setEnrollmentDate(false); // Deselect if already selected
    } else {
      setEnrollmentDate(sortType === 'enrollmentDate');
    }

    if (sortType === 'organization' && organization) {
      setOrganization(false); // Deselect if already selected
    } else {
      setOrganization(sortType === 'organization');
    }

    if (sortType === 'plan' && plan) {
      setPlan(false); // Deselect if already selected
    } else {
      setPlan(sortType === 'plan');
    }
  };



  return (
    <div className="relative inline-flex">
      <button
        ref={trigger}
        className="btn bg-white border-slate-200 hover:border-slate-300 text-slate-500 hover:text-slate-600"
        aria-haspopup="true"
        onClick={() => setDropdownOpen(!dropdownOpen)}
        aria-expanded={dropdownOpen}
      >
        <span className="sr-only">Filter</span>
        <svg
          className="w-4 h-4 fill-current"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10.5 16.5C6.36 16.5 3 13.14 3 9C3 4.86 6.36 1.5 10.5 1.5C14.64 1.5 18 4.86 18 9C18 13.14 14.64 16.5 10.5 16.5ZM10.5 3C7.42 3 5 5.42 5 9C5 12.58 7.42 15 10.5 15C13.58 15 16 12.58 16 9C16 5.42 13.58 3 10.5 3ZM21 21L16.5 16.5"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>
      <Transition
        show={dropdownOpen}
        tag="div"
        className="origin-top-right z-10 absolute top-full left-0 right-auto md:left-auto md:right-0 min-w-56 bg-white border border-slate-200 pt-1.5 rounded shadow-lg overflow-hidden mt-1"
        enter="transition ease-out duration-200 transform"
        enterStart="opacity-0 -translate-y-2"
        enterEnd="opacity-100 translate-y-0"
        leave="transition ease-out duration-200"
        leaveStart="opacity-100"
        leaveEnd="opacity-0"
      >
        <div ref={dropdown}>
          <div className="text-xs font-semibold text-slate-400 uppercase pt-1.5 pb-2 px-4">Filters</div>

          {/* Input fields for filtering by name or email */}
          <div className="py-1 px-3">
            <label className="flex items-center text-sm font-medium">
              <input
                type="text"
                className="form-input w-full"
                placeholder="Search ..."
                value={search}
                onChange={handleFilterChange}
              />
            </label>
          </div>

          {/* User type filter */}
          <div className="py-1 px-3">
            <label className="flex items-center text-sm font-medium">
              <select
                className="form-select w-full"
                value={userType}
                onChange={handleUserTypeChange}
              >
                <option value="">All Type</option>
                <option value="collab">Collaborator</option>
                <option value="owner">Owner</option>
              </select>
            </label>
          </div>
          <div className="py-1 px-3">
            <label className="flex items-center text-sm font-medium">
              <select
                className="form-select w-full"
                value={planType}
                onChange={handlePlanChange}
              >
                <option value="">All Plans</option>
                <option value="0">Free Plan</option>
                <option value="1">Agile Pro - Monthly</option>
                <option value="2">Agile Pro - Yearly</option>
                <option value="3">Transformation Catalyst - Monthly</option>
                <option value="4">Transformation Catalyst - Yearly</option>
                <option value="5">Enterprise Navigator</option>
              </select>
            </label>
          </div>
           <div className="py-1 px-3">
            <label className="flex items-center text-sm font-medium">
              <select
                className="form-select w-full"
                value={statusType}
                onChange={handleStatusChange}
              >
                <option value="">All Status</option>
                <option value="confirm_request_for_custom_plan">Awaiting Plan Confirmation</option>
                <option value="uncompleted_user_details">Profile Incomplete</option>
                <option value="active">Active</option>
              </select>
            </label>
          </div>
          <ul className="mb-4">
            <li className="py-1 px-3">
              <label className="flex items-center">
                <input
                  type="checkbox"
                  className="form-checkbox"
                  checked={lastLogin}
                  onChange={() => handleSortChange('lastLogin')}
                />
                <span className="text-sm font-medium ml-2">
                  Sort by Last Login
                </span>
              </label>
            </li>
            <li className="py-1 px-3">
              <label className="flex items-center">
                <input
                  type="checkbox"
                  className="form-checkbox"
                  checked={enrollmentDate}
                  onChange={() => handleSortChange('enrollmentDate')}
                />
                <span className="text-sm font-medium ml-2">
                  Sort by Enrollment Date
                </span>
              </label>
            </li>
            <li className="py-1 px-3">
              <label className="flex items-center">
                <input
                  type="checkbox"
                  className="form-checkbox"
                  checked={organization}
                  onChange={() => handleSortChange('organization')}
                />
                <span className="text-sm font-medium ml-2">
                  Sort by Organization
                </span>
              </label>
            </li>
            <li className="py-1 px-3">
              <label className="flex items-center">
                <input
                  type="checkbox"
                  className="form-checkbox"
                  checked={plan}
                  onChange={() => handleSortChange('plan')}
                />
                <span className="text-sm font-medium ml-2">
                  Sort by Plan
                </span>
              </label>
            </li>
          </ul>
        </div>
      </Transition>
    </div>
  );
}

export default FilterButton;
